<div class="backoffice-layout">
  <aside class="backoffice-sidebar">
    <div class="backoffice-brand-card">
      <div class="backoffice-brand-mark">
        <img src="/favicon.png" alt="The Gherkin Forge" />
      </div>
      <div>
        <div class="backoffice-brand-title">Backoffice Forge</div>
        <div class="backoffice-brand-subtitle">Pilotage admin en dark mode</div>
      </div>
    </div>

    <div class="backoffice-sidebar-section">
      <div class="backoffice-section-label">Navigation</div>
      <nav class="backoffice-nav">
        <a
          *ngFor="let item of navItems()"
          class="backoffice-nav-link"
          [routerLink]="item.route"
          routerLinkActive="backoffice-nav-link--active"
        >
          <span>{{ item.label }}</span>
          <small>{{ item.description }}</small>
        </a>
      </nav>
    </div>

    <div class="backoffice-sidebar-section backoffice-sidebar-section--spaced">
      <div class="backoffice-section-label">Session</div>
      <div class="backoffice-user-card" *ngIf="currentUser() as user">
        <strong>{{ user.firstName }} {{ user.lastName }}</strong>
        <span>{{ user.company?.name || 'Plateforme' }}</span>
        <small>{{ user.role === 'superadmin' ? 'Superadmin' : 'Company admin' }}</small>
      </div>
    </div>

    <div class="backoffice-sidebar-section">
      <div class="backoffice-section-label">RGPD</div>
      <div class="backoffice-compliance-card">
        <strong>Donnees personnelles</strong>
        <p>
          Le backoffice affiche des donnees nominatives uniquement pour l administration des comptes,
          des invitations, des licences et de la relation client.
        </p>
        <div class="backoffice-compliance-links">
          <a [routerLink]="privacyPolicyUrl">Privacy policy</a>
          <a [routerLink]="termsOfServiceUrl">Terms of service</a>
        </div>
      </div>
    </div>
  </aside>

  <main class="backoffice-main">
    <header class="backoffice-header">
      <div>
        <div class="backoffice-section-label">Administration</div>
        <h1>{{ shellTitle() }}</h1>
        <p>{{ shellSubtitle() }}</p>
      </div>

      <div class="backoffice-header-actions">
        <a
          *ngIf="canOpenPlatform()"
          class="secondary-button backoffice-platform-link"
          [routerLink]="platformRoute()"
        >
          Acceder a la plateforme
        </a>
        <button class="secondary-button" type="button" (click)="retry()" [disabled]="loading()">
          {{ loading() ? 'Actualisation...' : 'Actualiser' }}
        </button>
        <button class="primary-button" type="button" (click)="logout()">Se deconnecter</button>
      </div>
    </header>

    <section class="backoffice-kpi-grid" *ngIf="metrics() as metrics">
      <article class="backoffice-kpi-card">
        <span>{{ isSuperadmin() ? 'Admins visibles' : 'Utilisateurs' }}</span>
        <strong *ngIf="isSuperadmin(); else companyUsersKpi">{{ metrics.userCount }}</strong>
        <ng-template #companyUsersKpi>
          <strong>{{ allocatedLicenseCount() }} / {{ totalPurchasedLicenses() }} alloues</strong>
        </ng-template>
        <small>{{ metrics.pendingInvites }} invitation{{ metrics.pendingInvites > 1 ? 's' : '' }} en attente</small>
      </article>

      <article class="backoffice-kpi-card">
        <span>{{ isSuperadmin() ? 'Compagnies' : 'Licences' }}</span>
        <strong *ngIf="isSuperadmin(); else companyLicensesKpi">{{ metrics.companyCount }}</strong>
        <ng-template #companyLicensesKpi>
          <strong>{{ totalPurchasedLicenses() }} achetees</strong>
        </ng-template>
        <small>{{ isSuperadmin() ? 'Portefeuille plateforme' : remainingLicenseCount() + ' disponibles' }}</small>
      </article>

      <article class="backoffice-kpi-card">
        <span>{{ isSuperadmin() ? 'MRR estime' : 'Repartition des licences' }}</span>
        <strong *ngIf="isSuperadmin(); else companyDistributionKpi">
          {{ metrics.monthlyRevenueEuros | currency: 'EUR' : 'symbol' : '1.0-0' : 'fr' }}
        </strong>
        <ng-template #companyDistributionKpi>
          <strong>{{ companyPlanKpis().length }} plan{{ companyPlanKpis().length > 1 ? 's' : '' }}</strong>
        </ng-template>
        <small>{{ isSuperadmin() ? 'Calcul mensuel courant' : 'Utilisees / total achete par plan' }}</small>
        <div class="backoffice-kpi-breakdown" *ngIf="!isSuperadmin() && companyPlanKpis().length">
          <span *ngFor="let plan of companyPlanKpis()">
            <span class="backoffice-kpi-breakdown__line-main">{{ plan.label }}</span>
            <span class="backoffice-kpi-breakdown__line-value">{{ plan.used }} / {{ plan.purchased }} utilisees</span>
            <span class="backoffice-kpi-breakdown__flag" *ngIf="plan.isExhausted">Plus de disponibilite</span>
          </span>
        </div>
      </article>
    </section>

    <section
      class="backoffice-capacity-banner"
      *ngIf="capacityBanner() as banner"
      [ngClass]="'backoffice-capacity-banner--' + banner.tone"
    >
      <strong>Etat des allocations</strong>
      <p>{{ banner.message }}</p>
    </section>

    <section class="backoffice-alert-banner" *ngIf="error()">
      <div>
        <strong>Chargement incomplet</strong>
        <p>{{ error() }}</p>
      </div>
      <button class="secondary-button" type="button" (click)="retry()">Reessayer</button>
    </section>

    <router-outlet />

    <footer class="backoffice-legal-footer">
      <div class="backoffice-legal-footer__copy">
        <strong>{{ legalCompanyName }}</strong>
        <p>
          Backoffice access is restricted to authorized staff. Personal data must be used only for administration,
          license allocation, support, and customer-account operations. Website and infrastructure are powered by
          {{ legalHostingProvider }}.
        </p>
      </div>

      <nav class="backoffice-legal-footer__links" aria-label="Backoffice legal links">
        <a [routerLink]="privacyPolicyUrl">Privacy policy</a>
        <a [routerLink]="termsOfServiceUrl">Terms of service</a>
        <a [href]="cookiesPolicyUrl">Cookies</a>
        <a [href]="legalNoticeUrl">Mentions legales</a>
      </nav>
    </footer>
  </main>
</div>
